import { BrowserRouter, useLocation } from 'react-router-dom'
import { AppRoutes } from './router'
import SEOHead from './components/common/SEOHead'


function RoutesWithKey() {
  const location = useLocation()
  return <AppRoutes key={location.pathname} />
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SEOHead />
      <RoutesWithKey />
    </BrowserRouter>
  )
}

export default App